<template>
    <div v-wechat-title="title" class="form-table-h380">
        <list-view ref="recordOtherTemplatelist" :columns="columnList" :datalist="datalist" @extrabutton-click="ExtraButtonClick" :showSequence="true"></list-view>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `RecordOtherTemplate`,
    props: {},
    data() {
        return {
            title: `单据内容模板`,
            token: this.$route.query.token,
            id: this.$route.query.surgery_id,
            recordType: this.$route.query.record_type,
            datalist: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`ADD_CURRENTUSER`)
        this.init()
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `sys_enums`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `screenHeight`]),
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `template_name`,
                    label: `模板名称`,
                    isListable: true,
                    colspan: 5,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `360`,
                    isListable: true,
                    readonly: false,
                    options: function(that, { row }) {
                        if (row.id && row.id > 0) {
                            let rowbuttons = [{
                                class: `is-plain`,
                                label: `应用模板`,
                                icon: ``,
                                type: `primary`,
                                emit: `applyTemplate`,
                                permission: `default`
                            }, {
                                class: `is-plain`,
                                label: `删除`,
                                icon: ``,
                                type: `danger`,
                                emit: `removeRow`,
                                permission: `default`
                            }]
                            return rowbuttons
                        }
                    }
                }
            ]
        }
    },
    methods: {
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        init() {
            let that = this
            return new Promise((resolve) => {
                let req = that.myaxios.get(`/api/AcisSystem/AnesthsiaOtherTemplate/GetMe/${this.$route.query.surgery_id}?recordType=${this.recordType}`)
                req.then(data => {
                    that.datalist = data
                }).catch(e => { console.log(e) })
            })
        },
        removeRow({ row, index }) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/AcisSystem/AnesthsiaOtherTemplate/Delete/${row.id}`)
                req.then(() => {
                    that.init()
                }).catch(e => console.log(e))
            })
            // console.log(row,index)
        },
        applyTemplate({ row }) {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = { action: `ok`, data: { id: row.id } }
                winformMsg.acceptMessage(cefJson)
                this.$message.success(`模板应用成功`)
            }
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
        },
        region_type: function() {
            this.ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/RecordOtherTemplate.vue